import { render, staticRenderFns } from "./BillsListing.vue?vue&type=template&id=5f806872&scoped=true"
import script from "./BillsListing.vue?vue&type=script&lang=js"
export * from "./BillsListing.vue?vue&type=script&lang=js"
import style0 from "./BillsListing.vue?vue&type=style&index=0&id=5f806872&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f806872",
  null
  
)

export default component.exports